"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOnAccountEvent = void 0;
const order_helper_1 = require("@oolio-group/order-helper");
const uuid_1 = require("uuid");
function generateOnAccountEvent(action, sourceOptions, input) {
    const event = {
        ...(input || {}),
        action,
        customerId: input.customerId,
        id: (0, uuid_1.v4)(),
        timestamp: new Date().getTime(),
        ...order_helper_1.SOURCE_OPTIONS_ATTRS.reduce((acc, attr) => ({ ...acc, [attr]: sourceOptions[attr] }), {}),
        prevBalance: input.prevBalance,
        nextBalance: input.nextBalance,
    };
    return event;
}
exports.generateOnAccountEvent = generateOnAccountEvent;
//# sourceMappingURL=onAccountEventHelper.js.map